import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import Logo from "../../images/praxisbharwani_logo.svg";
import { Us, De } from "react-flags-select";

import { useTranslation } from "react-i18next";
import { API_BASE } from "../../config/api";

const Header = (props) => {
  const [menuActive, setMenuState] = useState(false);
  const [selectedLan, setSelectedLan] = useState("de");
  const [noticeCount, setNoticeCount] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLan);
  }, [i18n, selectedLan]);

  useEffect(() => {
    let ignore = false;
    const apiUrl = API_BASE;

    const isNoticeCurrentlyVisible = (notice, now = new Date()) => {
      if (!notice?.isActive) return false;

      const validFrom = notice.validFrom ? new Date(notice.validFrom) : null;
      const validTo = notice.validTo ? new Date(notice.validTo) : null;

      if (validFrom && !Number.isNaN(validFrom.getTime()) && validFrom > now) {
        return false;
      }

      if (validTo && !Number.isNaN(validTo.getTime()) && validTo < now) {
        return false;
      }

      return true;
    };

    const loadNoticesCount = async () => {
      try {
        const response = await fetch(`${apiUrl}/notices`);
        const data = await response.json().catch(() => []);

        if (!response.ok || ignore) return;

        const visibleNotices = (Array.isArray(data) ? data : []).filter(
          (notice) => isNoticeCurrentlyVisible(notice),
        );
        setNoticeCount(visibleNotices.length);
      } catch (_error) {
        if (!ignore) {
          setNoticeCount(0);
        }
      }
    };

    loadNoticesCount();

    return () => {
      ignore = true;
    };
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const onLanSelect = (lan) => {
    setSelectedLan(lan);
    i18n.changeLanguage(lan);
  };

  const jumpToHash = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const goToSection = (id) => {
    if (location.pathname !== "/") {
      sessionStorage.setItem("scrollTarget", id);
      navigate("/");
      return;
    }
    jumpToHash(id);
  };

  const openNoticeModal = () => {
    window.dispatchEvent(new CustomEvent("open-notice-modal"));
  };

  return (
    <header id="header" className={props.topbarNone}>
      <div className="praxis-linebar">
        <div className="container">
          <div className="praxis-linebar-inner">
            <div className="praxis-linebar-brand">
              <span>HAUSARZTPRAXIS</span>
              <strong>DR. BHARWANI</strong>
            </div>
            <a className="praxis-linebar-item" href="tel:+492114792626">
              <i className="fi flaticon-phone-call"></i>
              <span>0211 4792626</span>
            </a>
            <span className="praxis-linebar-item praxis-linebar-fax">
              <i className="fa fa-fax"></i>
              <span>0211/4963909</span>
            </span>
            <a
              className="praxis-linebar-item praxis-linebar-location"
              href="https://www.google.com/maps/search/?api=1&query=Kalkumer+Str.+151%2C+40468+D%C3%BCsseldorf"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fi flaticon-placeholder"></i>
              <span>Kalkumer Str. 151, 40468 Düsseldorf</span>
            </a>
            <button
              type="button"
              className="praxis-linebar-item praxis-linebar-news praxis-linebar-news-btn"
              onClick={openNoticeModal}
            >
              <i className="ti-agenda"></i>
              <span>{selectedLan === "de" ? "Aktuelles" : "News"}</span>
              <small>{noticeCount}</small>
            </button>
            <div className="praxis-linebar-lang">
              <button
                type="button"
                className={`praxis-linebar-lang-btn ${selectedLan === "en" ? "is-active" : ""}`}
                onClick={() => onLanSelect("en")}
              >
                <Us /> EN
              </button>
              <button
                type="button"
                className={`praxis-linebar-lang-btn ${selectedLan === "de" ? "is-active" : ""}`}
                onClick={() => onLanSelect("de")}
              >
                <De /> DE
              </button>
              <Link
                to="/admin"
                className="praxis-linebar-lang-btn praxis-linebar-admin-btn"
                aria-label="Admin login"
                title="Admin login"
              >
                <i className="ti-lock"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={`wpo-site-header ${props.hclass}`}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-6">
                <div className="navbar-header">
                  <Link onClick={ClickHandler} className="navbar-brand" to="/">
                    <img src={Logo} alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-7 col-lg-6 col-md-1 col-1">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li className="menu-item-has-children">
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          goToSection("angebot");
                        }}
                      >
                        {t("Our Services")}
                      </a>
                    </li>
                    <li className="menu-item-has-children">
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          goToSection("praxis");
                        }}
                      >
                        {t("Praxis")}
                      </a>
                    </li>
                    <li className="menu-item-has-children">
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          goToSection("team");
                        }}
                      >
                        {t("Team")}
                      </a>
                    </li>
                    <li className="menu-item-has-children">
                      <a href="/career" target="_blank" rel="noreferrer">
                        {t("Career")}
                      </a>
                    </li>
                    {/*<li className="menu-item-has-children">*/}
                    {/*    <a href="/" onClick={(e) => { e.preventDefault(); jumpToHash('about'); }}>{t('About Us')}</a>*/}
                    {/*</li>*/}
                    <li>
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          goToSection("bestellung");
                        }}
                      >
                        {t("Online Rezeptbestellung")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-2 col-2">
                <div className="header-right">
                  <div className="close-form">
                    <Link
                      onClick={props.openTerminModal}
                      className="theme-btn"
                      to="/"
                    >
                      {t("Book Now")}
                    </Link>
                  </div>
                  <div className="header-search-form-wrapper d-none d-lg-block">
                    <div className="cart-search-contact">
                      <button
                        onClick={() => setMenuState(!menuActive)}
                        className="search-toggle-btn"
                      >
                        <i
                          className={`fi ti-search ${menuActive ? "ti-close" : "ti-search"}`}
                        ></i>
                      </button>
                      <div
                        className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""}`}
                      >
                        <form onSubmit={SubmitHandler}>
                          <div>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here..."
                            />
                            <button type="submit">
                              <i className="fi flaticon-loupe"></i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
